export default {
  about: [
    {
      title: "연혁",
      link: "/about/history",
    },
    {
      title: "사업소개",
      link: "/about/business",
    },
    {
      title: "재무제표",
      link: "/about/financialStatements"
    }
  ],
  brand: [
    {
      title: "사보텐",
      link: "/brand/saboten/story",
      alternativeLink: "/brand/saboten",
    },
    {
      title: "히바린",
      link: "/brand/hibarin/story",
      alternativeLink: "/brand/hibarin",
    },
    {
      title: "타코벨",
      link: "http://koreatacobell.com/",
    },
    // {
    //   title: "센트럴키친",
    //   link: "/brand?modal=centralkitchen",
    // },
    {
      title: "리퍼크",
      link: "/brand?modal=reperk",
    },
    // {
    //     title: "Re-pulk",
    //     link: "",
    // },
  ],
  products: [
    {
      title: "돈카츠",
      link: "/products/homemade/katsu",
    },
    {
      title: "소스",
      link: "/products/homemade/sauce",
    },
  ],
  supports: [
    {
      title: "멤버쉽",
      link: "/supports/membership",
    },
    {
      title: "상품권",
      link: "/supports/giveaway",
    },
    {
      title: "제휴카드",
      link: "/supports/partnership",
    },
    {
      title: "카카오톡 친구",
      link: "/supports/kakaotalk-friends",
    },
    {
      title: "이벤트&프로모션",
      link: "/supports/events",
    },
  ],
  hr: [
    {
      title: "인재상",
      link: "/hr/talent",
    },
    {
      title: "교육",
      link: "/hr/education",
    },
    {
      title: "인사제도",
      link: "/hr/welfare",
    },
  ],
};
